import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { Button } from '@digital/ui';
import TextArea from 'antd/lib/input/TextArea';
import ListMensagem from './ListMensagem';
import { FromComentarioAContratar, ResultadoRelatorioPluriAnual, salvarComentarioAContratar } from '@app/api/crf/crfAContratar';
import { newGuid } from '@app/helpers/generatorGuid';

export interface PropsModalComentario {
    record: ResultadoRelatorioPluriAnual;
}

const ModalComentarioAContratar = (props: PropsModalComentario) => {
    const { record } = props;
    const [recarregarMensagem, setRecarregarMensagem] = useState(false);
    const [exibirModal, setExibirModal] = useState(false);
    const [iconeComentario, setIconeComentario] = useState('');
    const textAreaId = `textAreaId${newGuid()}`;

    useEffect(() => {
        if (record.possuiComentario)
            MudarIconeAnexo();
    }, [record]);

    const MudarIconeAnexo = () => {
        setIconeComentario('has-comments');
    };

    const limparCampo = () => {
        const elemento = document.getElementById(textAreaId);
        if (elemento != null) {
            document.getElementById(textAreaId).value = '';
        }
    };

    const getAll = async () => {
        setRecarregarMensagem(!recarregarMensagem);
    };

    const showModal = () => {
        limparCampo();
        setExibirModal(true);
    };

    const handleCancel = () => {
        limparCampo();
        setExibirModal(false);
    };

    const Salvar = (e: any) => {
        const text = document.getElementById(textAreaId).value;
        const consolidadoForm = {
            crfContaContabilCcId: record.crfContaContabilCcId,
            comentario: text,
        } as FromComentarioAContratar;


        salvarComentarioAContratar(consolidadoForm).then(data => {
            if (data && data.valid) {
                limparCampo();
                setRecarregarMensagem(!recarregarMensagem);
                MudarIconeAnexo();
            }
        });
    };

    return (
        <>
            <Tooltip title="Comentários">
                <Button
                    onClick={() => {
                        getAll();
                        showModal();
                    }}
                    icon="messaging-comments"
                    className={iconeComentario}
                />
            </Tooltip>
            <Modal
                title="Comentário"
                className="chat-modal"
                visible={exibirModal}
                onCancel={() => {
                    handleCancel();
                }}
                footer={[
                    <Button key="submit" type="link" icon="messaging-send" onClick={e => Salvar(e)}>
                        Enviar
                    </Button>,
                    <Button key="submit" type="primary" icon="commons-cancel" onClick={() => handleCancel()}>
                        Fechar
                    </Button>,
                ]}>
                <ListMensagem
                    crfContaContabilCcId={record.crfContaContabilCcId}
                    recarregarMensagem={recarregarMensagem}
                />
                <div className="chat-modal-message-box">
                    <Form>
                        <Form.Item>
                            <TextArea
                                id={textAreaId}
                                placeholder="mensagem"
                                autosize={{ minRows: 3, maxRows: 5 }}
                            />
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    );
};

export default ModalComentarioAContratar;
